import { useTheme } from "@emotion/react";
import React, { PropsWithChildren } from "react";

import { ThemeTextComponents } from "@brexhq/shared/types/modules/BlockRowsModule/BlockRowItems/TextRow";

import { Text } from "./Text";
import { BaseTextProps } from "./types";

export const migrationTextStyle = {
  "Display L": "Display S",
  "Display S": "Title L",
  "Title L": "Title M",
  "Title M": "Title S",
  "Title S": "Subtitle L",
  "Title S Regular": "Subtitle L",
  "Title XS": "Subtitle M",
  "Title XXS": "Subtitle S Regular",
  "Subtitle L": "Subtitle S Regular",
  "Subtitle S": "Body L",
  "[Bronzea] XXL": "Display S",
  "[Bronzea] XL": "Display S",
  "[Bronzea] L": "Display S",
  "[Bronzea] M": "Title L",
  "[Bronzea] S": "Title M",
  "[Flecha] L": "Flecha L",
  "[Flecha] M": "Flecha M",
  "[Flecha] S": "Flecha M",
  "[Flecha] XS": "Flecha S",
};

//FIXME: This file lives in shared because it is used both to render text on the site AND text previews in Sanity, but these should separated b/c Sanity cannot use our theme provider.

type TextProps = Partial<BaseTextProps>;

export const DisplayL: React.FC<PropsWithChildren<TextProps>> = ({
  children,
  margin,
  color,
  className,
  as = ThemeTextComponents[migrationTextStyle["Display L"]].as,
  fontWeightOverride,
}) => (
  <Text
    components={
      ThemeTextComponents[migrationTextStyle["Display L"]]?.components
    }
    as={as}
    margin={margin}
    color={color}
    className={className}
    fontWeightOverride={fontWeightOverride}
  >
    {children}
  </Text>
);

export const DisplayS: React.FC<PropsWithChildren<TextProps>> = ({
  children,
  margin,
  color,
  className,
  as = ThemeTextComponents[migrationTextStyle["Display S"]].as,
  fontWeightOverride,
}) => (
  <Text
    components={ThemeTextComponents[migrationTextStyle["Title S"]]?.components}
    as={as}
    margin={margin}
    color={color}
    className={className}
    fontWeightOverride={fontWeightOverride}
  >
    {children}
  </Text>
);

export const TitleL: React.FC<PropsWithChildren<TextProps>> = ({
  children,
  margin,
  color,
  className,
  as = ThemeTextComponents[migrationTextStyle["Title L"]].as,
  fontWeightOverride,
}) => (
  <Text
    components={ThemeTextComponents[migrationTextStyle["Title L"]]?.components}
    as={as}
    margin={margin}
    color={color}
    className={className}
    fontWeightOverride={fontWeightOverride}
  >
    {children}
  </Text>
);

export const TitleM: React.FC<PropsWithChildren<TextProps>> = ({
  children,
  margin,
  color,
  className,
  as = ThemeTextComponents[migrationTextStyle["Title M"]].as,
  fontWeightOverride,
}) => (
  <Text
    components={ThemeTextComponents[migrationTextStyle["Title M"]]?.components}
    as={as}
    margin={margin}
    color={color}
    className={className}
    fontWeightOverride={fontWeightOverride}
  >
    {children}
  </Text>
);

export const TitleS: React.FC<PropsWithChildren<TextProps>> = ({
  children,
  margin,
  color,
  className,
  as = ThemeTextComponents[migrationTextStyle["Title S"]].as,
  fontWeightOverride,
}) => (
  <Text
    components={ThemeTextComponents[migrationTextStyle["Title S"]]?.components}
    as={as}
    margin={margin}
    color={color}
    className={className}
    fontWeightOverride={fontWeightOverride}
  >
    {children}
  </Text>
);

export const TitleSReg: React.FC<PropsWithChildren<TextProps>> = ({
  children,
  margin,
  color,
  className,
  as = ThemeTextComponents[migrationTextStyle["Title S Regular"]].as,
  fontWeightOverride,
}) => (
  <Text
    components={
      ThemeTextComponents[migrationTextStyle["Title S Regular"]]?.components
    }
    as={as}
    margin={margin}
    color={color}
    className={className}
    fontWeightOverride={fontWeightOverride}
  >
    {children}
  </Text>
);

export const TitleXS: React.FC<PropsWithChildren<TextProps>> = ({
  children,
  margin,
  color,
  className,
  as = ThemeTextComponents[migrationTextStyle["Title XS"]].as,
  fontWeightOverride,
}) => (
  <Text
    components={ThemeTextComponents[migrationTextStyle["Title XS"]]?.components}
    as={as}
    margin={margin}
    color={color}
    className={className}
    fontWeightOverride={fontWeightOverride}
  >
    {children}
  </Text>
);

export const TitleXXS: React.FC<PropsWithChildren<TextProps>> = ({
  children,
  margin,
  color,
  className,
  as = ThemeTextComponents[migrationTextStyle["Title XXS"]].as,
  fontWeightOverride,
}) => (
  <Text
    components={
      ThemeTextComponents[migrationTextStyle["Title XXS"]]?.components
    }
    as={as}
    margin={margin}
    color={color}
    className={className}
    fontWeightOverride={fontWeightOverride}
  >
    {children}
  </Text>
);

export const SubtitleL: React.FC<PropsWithChildren<TextProps>> = ({
  children,
  margin,
  color,
  className,
  as = ThemeTextComponents[migrationTextStyle["Subtitle L"]].as,
  fontWeightOverride,
}) => (
  <Text
    components={
      ThemeTextComponents[migrationTextStyle["Subtitle L"]]?.components
    }
    as={as}
    margin={margin}
    color={color}
    className={className}
    fontWeightOverride={fontWeightOverride}
  >
    {children}
  </Text>
);

export const SubtitleS: React.FC<PropsWithChildren<TextProps>> = ({
  children,
  margin,
  color,
  className,
  as = ThemeTextComponents[migrationTextStyle["Subtitle S"]].as,
  fontWeightOverride,
}) => (
  <Text
    components={
      ThemeTextComponents[migrationTextStyle["Subtitle S"]]?.components
    }
    as={as}
    margin={margin}
    color={color}
    className={className}
    fontWeightOverride={fontWeightOverride}
  >
    {children}
  </Text>
);

export const BodyL: React.FC<PropsWithChildren<TextProps>> = ({
  children,
  margin,
  color,
  className,
  as = ThemeTextComponents["Body L"].as,
  fontWeightOverride,
}) => (
  <Text
    components={ThemeTextComponents["Body L"]?.components}
    as={as}
    margin={margin}
    color={color}
    className={className}
    fontWeightOverride={fontWeightOverride}
  >
    {children}
  </Text>
);

export const BodyM: React.FC<PropsWithChildren<TextProps>> = ({
  children,
  margin,
  color,
  className,
  as = ThemeTextComponents["Body M"].as,
  fontWeightOverride,
}) => (
  <Text
    components={ThemeTextComponents["Body M"]?.components}
    as={as}
    margin={margin}
    color={color}
    className={className}
    fontWeightOverride={fontWeightOverride}
  >
    {children}
  </Text>
);

export const BodyS: React.FC<PropsWithChildren<TextProps>> = ({
  children,
  margin,
  color,
  className,
  as = ThemeTextComponents["Body S"].as,
  fontWeightOverride,
}) => (
  <Text
    components={ThemeTextComponents["Body S"]?.components}
    as={as}
    margin={margin}
    color={color}
    className={className}
    fontWeightOverride={fontWeightOverride}
  >
    {children}
  </Text>
);

export const Legal: React.FC<PropsWithChildren<TextProps>> = ({
  children,
  margin,
  color,
  className,
  as = ThemeTextComponents["Legal"].as,
  fontWeightOverride,
}) => (
  <Text
    components={ThemeTextComponents["Legal"]?.components}
    as={as}
    margin={margin}
    color={color}
    className={className}
    fontWeightOverride={fontWeightOverride}
  >
    {children}
  </Text>
);

export const BronzeaL: React.FC<PropsWithChildren<TextProps>> = ({
  children,
  margin,
  color,
  className,
  as = ThemeTextComponents[migrationTextStyle["[Bronzea] L"]].as,
  fontWeightOverride,
}) => (
  <Text
    components={
      ThemeTextComponents[migrationTextStyle["[Bronzea] L"]]?.components
    }
    as={as}
    margin={margin}
    color={color}
    className={className}
    fontWeightOverride={fontWeightOverride}
  >
    {children}
  </Text>
);

export const BronzeaM: React.FC<PropsWithChildren<TextProps>> = ({
  children,
  margin,
  color,
  className,
  as = ThemeTextComponents[migrationTextStyle["[Bronzea] M"]].as,
  fontWeightOverride,
}) => (
  <Text
    components={
      ThemeTextComponents[migrationTextStyle["[Bronzea] M"]]?.components
    }
    as={as}
    margin={margin}
    color={color}
    className={className}
    fontWeightOverride={fontWeightOverride}
  >
    {children}
  </Text>
);

export const BronzeaS: React.FC<PropsWithChildren<TextProps>> = ({
  children,
  margin,
  color,
  className,
  as = ThemeTextComponents[migrationTextStyle["[Bronzea] S"]].as,
  fontWeightOverride,
}) => (
  <Text
    components={
      ThemeTextComponents[migrationTextStyle["[Bronzea] S"]]?.components
    }
    as={as}
    margin={margin}
    color={color}
    className={className}
    fontWeightOverride={fontWeightOverride}
  >
    {children}
  </Text>
);

export const FlechaL: React.FC<PropsWithChildren<TextProps>> = ({
  children,
  margin,
  color,
  className,
  as = ThemeTextComponents[migrationTextStyle["[Flecha] L"]].as,
  fontWeightOverride,
}) => (
  <Text
    components={
      ThemeTextComponents[migrationTextStyle["[Flecha] L"]]?.components
    }
    as={as}
    margin={margin}
    color={color}
    className={className}
    fontWeightOverride={fontWeightOverride}
  >
    {children}
  </Text>
);

export const FlechaM: React.FC<PropsWithChildren<TextProps>> = ({
  children,
  margin,
  color,
  className,
  as = ThemeTextComponents[migrationTextStyle["[Flecha] M"]].as,
  fontWeightOverride,
}) => (
  <Text
    components={
      ThemeTextComponents[migrationTextStyle["[Flecha] M"]]?.components
    }
    as={as}
    margin={margin}
    color={color}
    className={className}
    fontWeightOverride={fontWeightOverride}
  >
    {children}
  </Text>
);

export const FlechaS: React.FC<PropsWithChildren<TextProps>> = ({
  children,
  margin,
  color,
  className,
  as = ThemeTextComponents[migrationTextStyle["[Flecha] S"]].as,
  fontWeightOverride,
}) => (
  <Text
    components={
      ThemeTextComponents[migrationTextStyle["[Flecha] S"]]?.components
    }
    as={as}
    margin={margin}
    color={color}
    className={className}
    fontWeightOverride={fontWeightOverride}
  >
    {children}
  </Text>
);

export const FlechaXS: React.FC<PropsWithChildren<TextProps>> = ({
  children,
  margin,
  color,
  className,
  as = ThemeTextComponents[migrationTextStyle["[Flecha] XS"]].as,
  fontWeightOverride,
}) => (
  <Text
    components={
      ThemeTextComponents[migrationTextStyle["[Flecha] XS"]]?.components
    }
    as={as}
    margin={margin}
    color={color}
    className={className}
    fontWeightOverride={fontWeightOverride}
  >
    {children}
  </Text>
);

export const Detail: React.FC<PropsWithChildren<TextProps>> = ({
  as = "p",
  children,
  color,
  className,
  margin,
  fontWeightOverride,
}) => {
  const theme = useTheme();

  return (
    <Text
      margin={margin}
      as={as}
      // FIXME: This cast to any can be removed when this is no longer imported by Sanity
      color={color ?? (theme as any).colors.content.tertiary}
      className={className}
      components={{ LRG: "Caption", MED: "Caption", SML: "Caption" }}
      fontWeightOverride={fontWeightOverride}
    >
      {children}
    </Text>
  );
};

export const SpaceMonoS: React.FC<PropsWithChildren<TextProps>> = ({
  children,
  margin,
  color,
  className,
  as = ThemeTextComponents["Space Mono S"].as,
  fontWeightOverride,
}) => (
  <Text
    components={ThemeTextComponents["Space Mono S"]?.components}
    as={as}
    margin={margin}
    color={color}
    className={className}
    fontWeightOverride={fontWeightOverride}
  >
    {children}
  </Text>
);
